/* * 本页面为字典新增和字典修改界面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              prop="forms.dicTypeKey"
              label="请选择字典类型"
              :rules="[
                { required: true, message: '请选择字典类型', trigger: 'blur' }
              ]"
            >
              <el-select
                v-model="slotForms.forms.dicTypeKey"
                filterable
                placeholder="请选择字典类型"
                :disabled="editState"
              >
                <el-option
                  v-for="item in dicTypeKeyList"
                  :key="item.dicTypeKey"
                  :label="item.dicTypeName"
                  :value="item.dicTypeKey"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="字典名"
              prop="forms.dicName"
              :rules="[
                { required: true, message: '请输入字典名称', trigger: 'blur' },
                { validator: CheckRemarkLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.dicName"
                placeholder="字典名"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
``
<script>
import {
  FetchFindById,
  FetchSave,
  FetchDictionaryType
} from "@/api/systemSetting/dataDictionaryMaintenance";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import { CheckRemarkLength } from "@/utils/validation";

export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/systemSettingDataDictionaryMaintenanceList",
          isRedirect: true,
          meta: {
            title: "字典数据维护"
          }
        }
      ],
      formExtend: {
        forms: {
          dicTypeKey: "",
          dicName: "",
          carrierIds: [],
          areaIds: []
        },
        extends: []
      },
      dicTypeKeyList: [],
      carrierList: [],
      warehouseIdList: [],
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      loadingState: false
    };
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle = this.pageType === "1" ? "字典数据新增" : "字典数据修改";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    }
  },
  created() {
    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
    this.FetchDictionaryType();
    if (this.pageType !== "1") {
      this.FetchFindById({ id: this.id });
      this.editState = true;
    }
  },
  methods: {
    // 获取字典类型下拉框
    FetchDictionaryType() {
      FetchDictionaryType()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.dicTypeKeyList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 修改字典数据时，先获取字典数据信息
    FetchFindById(response) {
      FetchFindById(response)
        .then(response => {
          let carrierary = [];
          let areaAry = [];
          this.formExtend.forms = Object.assign({}, response.result);
          this.formExtend.forms.carrierIds.forEach(item => {
            carrierary.push(Number(item));
            console.log(item);
          });
          this.formExtend.forms.areaIds.forEach(item => {
            areaAry.push(Number(item));
            console.log(item);
          });
          this.formExtend.forms.areaIds = areaAry;
          this.formExtend.forms.carrierIds = carrierary;
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 新增，修改字典数据
    FetchSave(response) {
      FetchSave(response)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 新增、修改字典数据完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push("/systemSettingDataDictionaryMaintenanceList");
          }
          this.loadingState = false;
        }
      });
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        let data = {};
        if (this.pageType === "1") {
          data = mergeFormExtend(this.formExtend);
        } else {
          data = Object.assign(mergeFormExtend(this.formExtend), {
            peopleId: this.peopleId
          });
        }
        this.loadingState = true;
        this.FetchSave(data);
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/systemSettingDataDictionaryMaintenanceList");
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 20px 10px;
}

.content-section {
  overflow: auto;
}

.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}

/deep/ .e6-from--column-2 {
  .el-input {
    width: 240px;
  }
  .el-textarea__inner {
    width: 240px;
  }
}
</style>
